import { RootState } from '../index';
import { SubscriptionInfoStore } from './types';

export const subscriptionsInfoSelector = () => {
  return (state: RootState): SubscriptionInfoStore => {
    return state.subscriptionsInfo;
  };
};
